<template>
	<div
		id="app"
		class="-js-stickybit-parent"
		v-bind:class="{ iframe: isiFrame }"
	>
		<transition mode="out-in" name="appslide">
			<router-view name="app"></router-view>
		</transition>
		<a
			href
			id="toggle_code"
			class=" mr-2 ml-2"
			style="background: red; margin-bottom: 200px; top: 100px; right: -15px; color: white; padding: 4px 4px; border-radius: 50px; position: fixed; clear: both; z-index: 9999999;"
			@click.prevent="toggleCode"
		>
			&lt;&gt;</a
		>
		<!-- <powered-by /> -->
		<modal :modal="ajaxModal">
			{{ ajaxModal.ExceptionMessage }}
		</modal>
	</div>
</template>

<script>
	import Modal from '@/components/Modal.vue';
	import { mapActions, mapState, mapMutations } from 'vuex';

	export default {
		data() {
			return {
				ajaxModal: {
					show: false,
					ExceptionMessage: null,
					heading: 'We ran into a problem...',
				},
			};
		},
		methods: {
			...mapActions(['ajaxClient', 'ajaxOrder', 'startOver']),

			toggleCode() {
				window.$('body').toggleClass('enviroment_development');
			},

			//...mapActions(["ajaxClient"])

			// eslint-disable-next-line no-unused-vars
			handleScroll(event) {
				var logo_height = document.getElementById('client_logo').clientHeight;
				//console.log("logo_height: " + logo_height + " scroll: " + window.scrollY);
				if (window.scrollY >= logo_height) {
					// we're sticking
					document.getElementById('sticky_tabs').classList.add('sticking');
				} else {
					// not sticking
					document.getElementById('sticky_tabs').classList.remove('sticking');
				}
			},

			handleWindowFocus() {
				if (!document.hidden) {
					// cart focused & has an order key

					let reset = () => {
						this.$store.commit('forceUpdateOrder', {});
						this.$router.push({ path: '/' + this.$route.params.client });
					};

					let orderKey = localStorage.getItem('orderKey');

					if (this.order && this.order.OrderKey && !orderKey) {
						// order key has been cleared
						reset();
						return;
					}

					if (orderKey) {
						console.info(`Refreshing order ${orderKey}`);
						this.ajaxOrder(orderKey).then((order) => {
							if (!order) {
								// order is null/invalid
								reset();
							}
						});
					}
				}
			},
		},

		created() {
			window.addEventListener('scroll', this.handleScroll);

			window.$(document).ajaxStart(function() {
				//console.log("          $ajaxStart");
			});

			// eslint-disable-next-line
			window.$(document).ajaxComplete((event, xhr, settings) => {
				if (
					settings.url.toLowerCase().includes('addtocart') ||
					settings.url.toLowerCase().includes('completeorder')
				) {
					// console.log(xhr,event,settings)
					if (xhr.responseJSON && xhr.responseJSON.ExceptionMessage) {
						this.ajaxModal.show = true;
						this.ajaxModal.ExceptionMessage = xhr.responseJSON.ExceptionMessage;
					}
				}
			});
		},
		destroyed() {
			window.removeEventListener('scroll', this.handleScroll);
		},

		// beforeRouteUpdate(to, from, next) {
		//   alert("to");
		//   next();
		// },

		components: {
			Modal,
		},

		computed: {
			...mapState(['client', 'order', 'globalModal']),
			isiFrame: function() {
				try {
					return window.self !== window.top;
				} catch (e) {
					return true;
				}
			},
		},
		mounted() {
			// do we have a client object?
			// if (Object.keys(this.client).length === 0) {

			// }
			var b = document.getElementsByTagName('body')[0];
			b.classList.add('enviroment_' + this.$store.state.environment);

			b.classList.add('appCodeName-' + navigator.appCodeName);
			b.classList.add('platform-' + navigator.platform);

			if ('ontouchstart' in window) {
				b.classList.add('touch');
			} else {
				b.classList.add('no_touch');
			}

			let urlParams = new URLSearchParams(window.location.search);
			if (urlParams.get('iframeModal')) {
				localStorage.setItem('iframeModal', true);
				b.classList.add('iframe-modal');
			} else {
				console.log('params', this.$route.query);
			}

			document.addEventListener('visibilitychange', () => {
				this.handleWindowFocus();
			});
		},

		watch: {
			'$store.state.order': {
				deep: true,
				handler(order) {
					var activities = [];
					order.Individual.forEach((pkg) => {
						pkg.Activities.forEach((item) => {
							activities.push({
								Name: item.Name,
								Quantity: item.TotalParticipants,
								SubTotal: item.SubTotal,
							});
						});
					});
					order.Packages.forEach((pkg) => {
						pkg.Activities.forEach((item) => {
							activities.push({
								Name: item.Name,
								Quantity: item.TotalParticipants,
								SubTotal: item.SubTotal,
							});
						});
					});
					var products = [];
					order.Products.forEach((item) => {
						products.push({
							Name: item.ProductName,
							Quantity: item.Quantity,
							SubTotal: item.SubTotal,
						});
					});
					if (window.parent) {
						window.parent.postMessage(
							{
								SubTotal: order.SubTotal,
								Activities: activities,
								AddOns: products,
								OrderKey: order.OrderKey,
							},
							'*'
						);
					}
				},
			},
			'$route.params': function() {
				if (!this.client.Active) {
					this.ajaxClient({
						client: this.$route.params.client,
					});
				}
			},
		},
	};
</script>

<style lang="scss">
	@import './assets/css/main.scss';
	@import './assets/css/_avenir.scss';
	.iframe-modal {
		visibility: hidden;
		#individual_details {
			visibility: visible;
		}
		.shop_table {
			visibility: hidden;
		}
	}
	body {
		background-color: transparent;
	}
</style>
